// Elements
require("webstrap/type");
require("webstrap/buttons");
require("element/rich-text");

// Styles
require("./cta.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/cta/index.js
 ** module id = 163
 ** module chunks = 0 1
 **/